// Builds product tabs out of the headings in the product description. The row keeps
// the accordion appearance, but opens its content in a slideout panel, matching the
// tabs rendered by snippets/product-tab.liquid

function tabId(heading, index) {
  var slug = heading.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  return 'product-tab-desc-' + index + (slug ? '-' + slug : '');
}

function createTab(heading, id) {
  var $tab = $(
    '<div class="accordion">' +
      '<button type="button" class="accordion__toggle h6" aria-controls="' + id + '" aria-expanded="false" aria-haspopup="dialog">' +
        '<span class="text-with-icon gap-4"></span>' +
        '<span class="animated-plus" aria-hidden="true"></span>' +
      '</button>' +
      '<x-drawer id="' + id + '" class="slideout drawer color-scheme color-scheme--dialog slideout--lg" open-from="right">' +
        '<span class="h5" slot="header"></span>' +
        '<div class="prose"><div class="Rte"></div></div>' +
      '</x-drawer>' +
    '</div>'
  );

  $tab.find('.text-with-icon, [slot="header"]').text(heading);

  return $tab;
}

function productDescTabs() {
  let $desc = $("[data-block-type='description']");
  let $tabs = $(".Product__Tabs");
  let tabs = [];
  // create tabs from content
  $desc.find("h2, h3, h4, h5, h6").each(function (index) {
    let $heading = $(this);
    let $list = $heading.next();
    if (!$list || !$list.is("ul, p")) {
      return;
    }
    let heading = $heading.text();
    let $tab = createTab(heading, tabId(heading, index));
    $tab.find(".Rte").append($list);
    $heading.remove();
    tabs.push($tab);
  });
  $.each(tabs.reverse(), function (i, $tab) {
    $tabs.prepend($tab);
  });
}

// events
(function ($) {
  if (window.theme.pageType === "product") {
    productDescTabs();
  }
})(jQuery);
